import {
  ManagedMessenger,
  TRUST_LEVELS,
  targetContextFromWindow,
  noopLogger,
  noopMetrics,
  object,
  record,
  string,
} from '@sail/comms';
import {SAIL_TOOLKIT_ACTIVE, SAIL_TOOLKIT_COMMUNICATION_ID} from './constants';

function createMessenger() {
  const schemasByType = {
    SAIL_UI_READY: object({}),
    SAIL_TOKEN_OVERRIDE: record(string(), string()),
    SAIL_PROBE: object({}),
  };
  return new ManagedMessenger({
    self: {
      context: targetContextFromWindow(window),
      trustLevel: TRUST_LEVELS.TRUSTED,
    },
    remote: {
      context: targetContextFromWindow(window),
      origin: window.location.origin,
      trustLevel: TRUST_LEVELS.TRUSTED,
    },
    logger: noopLogger,
    metrics: noopMetrics,
    schemasByType,
    communicationId: SAIL_TOOLKIT_COMMUNICATION_ID,
    trustLocalhostOrigins: true,
  });
}

export const messenger = SAIL_TOOLKIT_ACTIVE ? createMessenger() : null;
